export type VatAccount =
    | VatAccountFree
    | VatAccountStandard
    | VatAccountSpecial
    | VatAccountCustom;

interface VatAccountBase {
    id: string;
    vatOwnerOrganisationId: number;
    vatAddress: VatAddress;
    createdAt: string;
    createdByAdminId: number;
    active: boolean;
    vatRate: VatRateType;
}

export enum VatRateType {
    FREE = 'FREE',
    STANDARD = 'STANDARD',
    SPECIAL = 'SPECIAL',
    CUSTOM = 'CUSTOM',
}

export interface VatAddress {
    organisationName: string;
    street: string;
    zipCode: string;
    city: string;
}

export interface VatAccountFree extends VatAccountBase {
    vatRate: VatRateType.FREE;
}

export interface VatAccountStandard extends VatAccountBase {
    vatNumber: string;
    currentPercent: number;
    vatRate: VatRateType.STANDARD;
}

export interface VatAccountSpecial extends VatAccountBase {
    vatNumber: string;
    currentPercent: number;
    vatRate: VatRateType.SPECIAL;
}

export interface VatAccountCustom extends VatAccountBase {
    vatNumber: string;
    customPercent: number;
    vatRate: VatRateType.CUSTOM;
}
